export function sortByActiveStatus (a, b) {
  const isActive = (contract) => contract.statusCode.toUpperCase() === 'ACTIVE'

  return isActive(a) || !isActive(b) ? -1 : 0
}
